import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class PredefinedMesgStore {
  loading = false;
  total = 0;
  messageList = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      messageList: observable,

      loadData: action,
      deleteRecord: action,

      addData: action,
      getMessageData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, page }) {
    this.loading = true;
    var postData = {
      offset: offset,
      limit: limit,
      page: page,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=predefinedMessage&a=predefinedMessageList",
        "postData=" + base64Input
      );

    this.messageList = response?.data?.data?.MessageData;
    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async addData(messageData) {
    var postData = messageData;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=predefinedMessage&a=update", "postData=" + base64Input);

    return response.data;
  }

  async getMessageData(id) {
    var postData = {
      id: id,
      limit: 1,
      offset: 0,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=predefinedMessage&a=predefinedMessageList",
        "postData=" + base64Input
      );

    return response?.data?.data?.MessageData[0];
  }

  async deleteRecord({ id }) {
    const postData = { Id: id };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=predefinedMessage&a=delete", "postData=" + base64Input);

    return response;
  }
}

export default PredefinedMesgStore;
